import { apiGet, apiPost } from '../api-client.ts';

interface OperatoreItem {
  idFenice: number;
  nome: string;
  cognome: string;
  territorio: string | null;
}

interface CercaResult {
  locali: OperatoreItem[];
  remoti: OperatoreItem[];
}

interface ListaResult {
  operatori: OperatoreItem[];
}

export const operatoriApi = {
  lista: () => apiGet<ListaResult>('operatori'),

  dettaglio: (idFenice: number) => apiGet<OperatoreItem>(`operatori/${idFenice}`),

  cerca: (q: string) => apiGet<CercaResult>(`operatori/cerca?q=${encodeURIComponent(q)}`),

  salvaCache: (op: OperatoreItem) => apiPost<{ ok: boolean }>('operatori/cache', op),
};
